// Simple service for account operations — replace base URLs as needed
import { request } from './http';
const API_BASE = process.env.REACT_APP_API_URL || '';
const USE_MOCK = !API_BASE || API_BASE === '';
const STORAGE_KEY = 'geppro_account';

export async function saveAccount(data) {
  if (USE_MOCK) {
    return new Promise((resolve) => {
      setTimeout(() => {
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
          resolve({ success: true, account: data });
        } catch (err) {
          resolve({ success: false, error: err.message });
        }
      }, 200);
    });
  }
  try {
    const url = `${API_BASE}/api/account`;
    // If there's a file, send FormData (do not set Content-Type)
    if (data.file instanceof File) {
      const form = new FormData();
      Object.keys(data).forEach(key => {
        if (key === 'file') return;
        if (data[key] !== undefined && data[key] !== null) form.append(key, data[key]);
      });
      form.append('avatar', data.file);
      const res = await request(url, { method: 'POST', body: form });
      if (!res.ok) throw new Error(await res.text());
      return res.json();
    }

    // JSON body
    const res = await request(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  } catch (err) {
    console.warn('API failed, using mock:', err);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      return { success: true, account: data };
    } catch (e) {
      throw err;
    }
  }
}

// Logout: try server-side logout but always clear client auth afterwards
export async function logout() {
  if (!USE_MOCK) {
    const url = `${API_BASE}/api/logout`;
    try {
      // fire request; request() attaches Authorization header from localStorage
      await request(url, { method: 'POST' });
    } catch (err) {
      // ignore server errors — we'll still clear client auth
    }
  }
  try { window.localStorage.removeItem('authToken'); } catch (e) {}
  try { window.localStorage.removeItem('auth.tokens.v1'); } catch (e) {}
  return true;
}

export async function deleteAccount() {
  if (USE_MOCK) {
    return new Promise((resolve) => {
      setTimeout(() => {
        try {
          localStorage.removeItem(STORAGE_KEY);
          localStorage.removeItem('authToken');
          localStorage.removeItem('auth.tokens.v1');
          resolve({ success: true });
        } catch (err) {
          resolve({ success: false, error: err.message });
        }
      }, 200);
    });
  }
  try {
    const url = `${API_BASE}/api/account`;
    const res = await request(url, { method: 'DELETE' });
    if (!res.ok) throw new Error(await res.text());
    return true;
  } catch (err) {
    console.warn('API failed, using mock:', err);
    localStorage.removeItem(STORAGE_KEY);
    return { success: true };
  }
}

export default { saveAccount, logout, deleteAccount };
